<template>
  <div>
    <v-hover v-slot:default="{ hover }" :disabled="disabled">
      <v-card
        flat
        height="175"
        width="175"
        :class="[
          'rounded-10',
          'blue-border',
          { 'btn-primary': hover, 'disabled-button': disabled }
        ]"
        @click="$emit('chooseOrder', 'DESIGN')"
      >
        <v-card-text
          class="px-1 text-center text-subtitle-1 pb-0"
          :style="{
            color: hover ? 'white' : '#147BD1'
          }"
        >
          <strong> TOOTH DESIGN ONLY </strong>
        </v-card-text>
        <v-container fluid>
          <v-img
            v-if="!hover"
            contain
            :src="require('@/assets/design-only-prosthesis.png')"
            position="center center"
          />
          <v-img
            v-if="hover"
            contain
            :src="require('@/assets/design-only-prosthesis-white.png')"
            position="center center"
          />
        </v-container>
      </v-card>
    </v-hover>
    <v-card flat max-width="275px">
      <v-card-actions class="pb-0">
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="ml-2"
              elevation="0"
              fab
              x-small
              @click="collapsed = !collapsed"
            >
              <v-icon>
                {{ collapsed ? "mdi-information-outline" : "mdi-chevron-up" }}
              </v-icon>
            </v-btn>
          </template>
          <span>Click for further info</span>
        </v-tooltip>
        <v-spacer />
      </v-card-actions>
      <v-card-text class="text-left pa-2 pb-0">
        <ul>
          <li class="font-weight-bold pb-1">Osteon designed full-arch.</li>
          <li class="pb-1">Choose direct to MUA or Ti base.</li>
          <li class="pb-1">.STL provided for lab production.</li>
          <li class="pb-1">You will receive a HTML file for review.</li>
          <li class="pb-1">
            Once the .STL is uploaded, the case will be closed.
          </li>
          <li>Requires necessary scans and photos.</li>
        </ul>
      </v-card-text>
      <v-expand-transition>
        <v-card-text class="py-2 mx-2 text-left" v-if="!collapsed">
          <v-divider class="py-1" />
          Tooth designs ordered from Osteon Medical are per arch and require the
          standard restorative scans and patient photos for accurate design.
          <br />
          <a
            href="https://nexusconnectlab.zendesk.com/hc/en-us/articles/12443735911567-Design-Only-Order"
            target="_blank"
            >Find out more via the Knowledge Base.</a
          >
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "DesignButton",

  props: ["disabled"],

  data() {
    return {
      collapsed: true
    }
  }
}
</script>

<style scoped>
.disabled-button {
  cursor: not-allowed;
  pointer-events: none;
  filter: grayscale(10%) brightness(80%);
  opacity: 0.5;
}
</style>
